import { GET_ORDER_REPORT_LIST, GET_ORDER_REPORT_LIST_SUCCESS } from '../storeTypes';

const INIT_STATE = {
  loader: false,
  orderReportList: [],
};

function OrderReportReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ORDER_REPORT_LIST: {
      return {
        ...state,
        orderReportList: [],
        loader: true,
      };
    }
    case GET_ORDER_REPORT_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        orderReportList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

export default OrderReportReducer;
